/* eslint complexity: 0 */
import {
    SET_DESTINATION_URGENCY_MEASUREMENTS,
    SET_DESTINATION_INFOGRAPHIC,
    SET_LISTINGS,
    SET_QUICK_SERP_FILTERS,
    SET_UNIT_REVIEWS,
    LOADING_LISTINGS,
    FAILED_LISTINGS
} from '../actions/action-types';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_DESTINATION_URGENCY_MEASUREMENTS:
            return {
                ...state,
                urgencyMessage: action.payload
            };
        case SET_DESTINATION_INFOGRAPHIC:
            return {
                ...state,
                infographic: action.payload
            };
        case SET_UNIT_REVIEWS:
            return {
                ...state,
                reviews: action.payload
            };
        case SET_QUICK_SERP_FILTERS:
            return {
                ...state,
                quickSeRPFilters: action.payload
            };
        case SET_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    inventoryCount: action.inventoryCount,
                    loading: false
                },
                listings: action.listings,
                lastCardUrl: action.lastCardUrl
            };
        case LOADING_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    failed: false,
                    loading: true,
                    key: action.segmentKey,
                    timeoutMs: action.timeoutMs
                }
            };
        case FAILED_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    loading: false,
                    failed: true,
                    timeoutMs: state.segmentFilters.timeoutMs * 2
                }
            };
        default:
            return state;
    }
};
